import ContentGate from './content-gate';
import './content-gate.scss';

export default ContentGate;
